<template>
  <CustomModal
    :title="`Add ${providerName} API Key`"
    :visible="visible"
    @update:visible="handleClose"
    width="32vw"
    position="top"
  >
    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-1">
        <span class="text-[13px] secondary_color">Account Name</span>
        <a-input
          v-model:value="accountName"
          :class="['input_medium', { input_error: accountNameError }]"
          placeholder="Enter account name"
          @input="accountNameError = ''"
          @blur="validateAccountName"
        />
        <span v-if="accountNameError" class="error_message_color text-xs mt-1">
          {{ accountNameError }}
        </span>
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-[13px] secondary_color">API Key</span>
        <a-input
          v-model:value="apiKey"
          :class="['input_medium', { input_error: apiKeyError }]"
          placeholder="Enter API key"
          @input="apiKeyError = ''"
          @blur="validateApiKey"
        />
        <span v-if="apiKeyError" class="error_message_color text-xs mt-1">
          {{ apiKeyError }}
        </span>
      </div>

      <span v-if="serverError" class="error_message_color text-xs">
        {{ serverError }}
      </span>
    </div>

    <template #footer>
      <div class="flex gap-2">
        <a-button class="secondary_medium" @click="handleClose(false)">Cancel</a-button>
        <a-button class="primary_medium" :loading="submitting" @click="handleSubmit">
          {{ submitting ? "Adding..." : "Add Account" }}
        </a-button>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import { ref, watch } from "vue";
import CustomModal from "@/src/components/CustomModal.vue";

const props = defineProps({
  visible: { type: Boolean, default: false },
  providerName: { type: String, default: "Provider" },
  submitting: { type: Boolean, default: false },
  serverError: { type: String, default: "" },
});

const emit = defineEmits(["update:visible", "account-added"]);

const accountName = ref("");
const apiKey = ref("");
const accountNameError = ref("");
const apiKeyError = ref("");

const validateAccountName = () => {
  if (!accountName.value?.trim()) accountNameError.value = "Account name is required";
};

const validateApiKey = () => {
  if (!apiKey.value?.trim()) apiKeyError.value = "API key is required";
};

const reset = () => {
  accountName.value = "";
  apiKey.value = "";
  accountNameError.value = "";
  apiKeyError.value = "";
};

const handleClose = (value) => {
  emit("update:visible", value);
  if (!value) reset();
};

const handleSubmit = () => {
  validateAccountName();
  validateApiKey();
  if (accountNameError.value || apiKeyError.value) return;
  emit("account-added", {
    accountName: accountName.value.trim(),
    apiKey: apiKey.value.trim(),
  });
};

watch(() => props.visible, (val) => { if (!val) reset(); });
</script>

<style scoped>
.input_error {
  border: 1px solid var(--error-color) !important;
}
</style>
